import { render, staticRenderFns } from "./IconPageNotFound.vue?vue&type=template&id=efd7d20c&scoped=true"
import script from "./IconPageNotFound.vue?vue&type=script&lang=js"
export * from "./IconPageNotFound.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efd7d20c",
  null
  
)

export default component.exports